import { render, staticRenderFns } from "./ckItem.vue?vue&type=template&id=232b7c5c&scoped=true&"
import script from "./ckItem.vue?vue&type=script&lang=js&"
export * from "./ckItem.vue?vue&type=script&lang=js&"
import style0 from "./ckItem.vue?vue&type=style&index=0&id=232b7c5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232b7c5c",
  null
  
)

export default component.exports